
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/card-action-area",
      function () {
        return require("private-next-pages/material-ui/api/card-action-area.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/card-action-area"])
      });
    }
  